import React from 'react';

import ProductList from '../../../../components/PolicySelection/ProductList.component';

const Products = ({ filterProduct, finishSelection }: any) => {
  return (
    <>
      <ProductList
        header_title="¿Qué producto querés modificar?"
        subtitle=""
        filter_product={filterProduct}
        finish_selection={finishSelection}
      />
    </>
  );
};

export default Products;
